/**
 * index.ts - Draggr - Universal drag & drop with file export
 * 
 * CHANGE HISTORY:
 * - 251108_1245 [current] danielbeer: feat: Switch to Pragmatic drag and drop
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */

// Export new Pragmatic-based DraggrManager (preferred)
import { DraggrManager as DraggrManagerPragmatic } from './DraggrManagerPragmatic';
export { DraggrManager } from './DraggrManagerPragmatic';
export type {
  DraggableConfig,
  DroppableConfig,
  FileExportConfig,
  DraggrManagerOptions,
} from './DraggrManagerPragmatic';

// Export modern React hooks (RECOMMENDED)
export { usePragmaticDraggable, usePragmaticDropTarget, usePragmaticContextAware } from './hooks';
export type { UseDraggableConfig, UseDropTargetConfig, ContextAwareConfig } from './hooks';

// Export test component
export { DraggrTest } from './test/DraggrTest';

// Export legacy components (for backward compatibility)
import { DraggrManager as DraggrManagerLegacyImport } from './DraggrManager';
import { FileSourceManager as FileSourceManagerImport } from './FileSourceManager';
import { DraggrProvider as DraggrProviderImport, useDraggr as useDraggrImport, useDraggable as useDraggableImport, useDroppable as useDroppableImport, useFileExport as useFileExportImport } from './DraggrContext';
import { DragPreview as DragPreviewImport, DropZoneIndicator as DropZoneIndicatorImport, FileExportIndicator as FileExportIndicatorImport } from './DragPreview';

export { DraggrManagerLegacyImport as DraggrManagerLegacy };
export { FileSourceManagerImport as FileSourceManager };
export { DraggrProviderImport as DraggrProvider, useDraggrImport as useDraggr, useDraggableImport as useDraggable, useDroppableImport as useDroppable, useFileExportImport as useFileExport };
export { DragPreviewImport as DragPreview, DropZoneIndicatorImport as DropZoneIndicator, FileExportIndicatorImport as FileExportIndicator };
// export * from './adapters/index'; // TODO: Create adapters directory

export default {
  DraggrManager: DraggrManagerPragmatic,
  FileSourceManager: FileSourceManagerImport,
  DraggrProvider: DraggrProviderImport,
  useDraggr: useDraggrImport,
  useDraggable: useDraggableImport,
  useDroppable: useDroppableImport,
  useFileExport: useFileExportImport,
  DragPreview: DragPreviewImport,
  DropZoneIndicator: DropZoneIndicatorImport,
  FileExportIndicator: FileExportIndicatorImport
};
